import { LoanType } from '@apply/constants';
import { useApplicationCache } from './useApplicationCache';

/**
 * Reads the loan type from the React Query application cache without making an API call.
 * Shared by Property and Borrower sections.
 */
export function useLoanTypeCache(): LoanType | null {
    return useApplicationCache(d => d.information?.borrower?.loanType ?? null) ?? null;
}
